import React, { useState } from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import ConfirmationPopup from '../ui/ConfirmationPopup';

interface TimelineActionsProps {
  entryId: string;
  onEdit: () => void;
  onDelete: () => void;
}

export default function TimelineActions({ entryId, onEdit, onDelete }: TimelineActionsProps) {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDelete = async () => {
    try {
      const { error } = await supabase
        .from('nrm_timeline_entries')
        .delete()
        .eq('id', entryId);

      if (error) throw error;
      onDelete();
    } catch (err) {
      console.error('Failed to delete entry:', err);
    }
  };

  return (
    <>
      <div className="flex gap-2">
        <button
          onClick={onEdit}
          className="text-gray-400 hover:text-white"
          title="Edit entry"
        >
          <Edit className="w-4 h-4" />
        </button>
        <button
          onClick={() => setShowDeleteConfirm(true)}
          className="text-gray-400 hover:text-red-500"
          title="Delete entry"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>

      {showDeleteConfirm && (
        <ConfirmationPopup
          title="Delete Entry"
          message="Are you sure you want to delete this timeline entry? This action cannot be undone."
          confirmLabel="Delete"
          onConfirm={() => {
            handleDelete();
            setShowDeleteConfirm(false);
          }}
          onCancel={() => setShowDeleteConfirm(false)}
        />
      )}
    </>
  );
}